// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum TraceOutcome {
  Ok = 0,
  Dropped = 1,
  Error = 2,
  Timeout = 3,
  Skipped = 4,
}
